<template>
  <div>
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('reports.rpt_course_overview')" class="text-pre"></page-header-title>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex float-right">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs3>&nbsp;</v-flex>
            <v-flex xs9>
              <v-select
                v-model="search_params.period"
                item-text="text"
                item-value="key"
                :items="this.$dd_chart_period_filter()"
                :label="$t('reports.filter_period')"
                @change="fillData"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <bar :chart-data="dataCollection" :options="chartOptions"></bar>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
    bar: () => import("./js/Bar.js")
  },
  data() {
    return {
      search_params: {
        period: "last-3-months"
      },
      dataCollection: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true
            }
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                precision: 0
              }
            }
          ]
        },
        legend: { display: true }
      }
    }
  },
  mounted() {
    this.fillData()
  },
  methods: {
    fillData() {
      let query = "?period=" + this.search_params.period

      axios
        .get(this.API_URL + "report/course-overview/chart" + query)
        .then((res) => {
          let data = res.data
          this.dataCollection = res.data
        })
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style scoped></style>
